export {
  TOASTER_TYPE,
  LANGUAGES,
  TOKEN,
  LANGUAGE,
  ADMIN_ID,
  ROLE,
  OPERATOR_ROLES,
  ROUTE_PATHS,
  LOADER_TYPE,
  METHOD_TYPES,
  LOADER_HANDLER_TYPES,
  TABLE_CELL_TYPE,
  DIALOG_TYPE,
  DEFAULT_PAGE_NO,
  DEFAULT_CURRENCY_ID
} from 'utils/constants/index'

export const BET_LIMIT_TYPES = Object.freeze({
  NO_LIMIT: 'NO_LIMIT',
  POT_LIMIT: 'POT_LIMIT',
  FIXED_LIMIT: 'FIXED_LIMIT'
})

export const BET_LIMIT_OPTIONS = [
  { id: 1, label: 'No Limit', value: BET_LIMIT_TYPES.NO_LIMIT },
  { id: 2, label: 'Pot Limit', value: BET_LIMIT_TYPES.POT_LIMIT },
  { id: 3, label: 'Fixed Limit', value: BET_LIMIT_TYPES.FIXED_LIMIT }
]

export const GAMES = {
  POKER_TEXAS_HOLDEM: "Texas Hold'em",
  POKER_OMAHA_PLO_4: 'Omaha PLO 4',
  POKER_OMAHA_PLO_5: 'Omaha PLO 5',
  POKER_OMAHA_PLO_6: 'Omaha PLO 6',
  POKER_SHORT_DECK: 'Short Deck',
  TOURNAMENT: 'Tournament'
}

/** Poker game IDs — aligned with admin backend games seeder */
export const DEFAULT_GAME_ID = {
  POKER_TEXAS_HOLDEM: 1,
  POKER_OMAHA_PLO_4: 2,
  POKER_OMAHA_PLO_5: 3,
  POKER_OMAHA_PLO_6: 4,
  POKER_SHORT_DECK: 5,
  TOURNAMENT: 6
}

export const GAME_MAX_PLAYER_LIMITS = {
  [DEFAULT_GAME_ID.POKER_TEXAS_HOLDEM]: 9,
  [DEFAULT_GAME_ID.POKER_OMAHA_PLO_4]: 9,
  [DEFAULT_GAME_ID.POKER_OMAHA_PLO_5]: 8,
  [DEFAULT_GAME_ID.POKER_OMAHA_PLO_6]: 7,
  [DEFAULT_GAME_ID.POKER_SHORT_DECK]: 6
}
